import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";

export const CalendarSidebarWrapper = styled.div`
  padding: ${toRem(16)};
  display: flex;
  flex-direction: column;
  gap: ${toRem(16)};
  border-right: 1px solid ${COLORS.BORDER.SOFT};
`

export const CalendarSidebarTitle = styled.h1`
  padding: ${toRem(16)} 0 ${toRem(12)};
  font-weight: 700;
  font-size: ${toRem(28)};
  line-height: ${36 / 28};
`

export const CalendatSidebarSelectWrapper = styled.div`
  padding-top: ${toRem(16)};
  .dropdown {
    width: 100%;
    --input-m-label-font: 500 ${toRem(16)}/${toRem(20)} var(--font-family)
  }
`